import React from "react"
import PropTypes from "prop-types"

const ArrowTop = ({ fillColor }) => (
  <svg
    width="12"
    height="6"
    viewBox="0 0 12 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 0L0 6H12L6 0Z" fill={fillColor} />
  </svg>
)

ArrowTop.propsTypes = {
  fillColor: PropTypes.string,
}

ArrowTop.defaultProps = {
  fillColor: "#6A736C",
}

export { ArrowTop }
